import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { OhioOutgoingTitleDto, OhioOutgoingTitleQueryParams } from 'dtos/ohioOutgoingTitles'
import { OhioOutgoingTitlesParameters } from 'parameters/ohioOutgoingTitlesParameters'
import { URIQuery } from 'utils'

export const getOhioOutgoingTitleGroups = (queryParams: OhioOutgoingTitleQueryParams) =>
  apiClient.get<ApiResponse<OhioOutgoingTitleDto[]>>(`/api/ohio-outgoing-titles` + URIQuery(queryParams)).then(response => response.data)

export const getOhioOutgoingTitleGroup = (ohioOutgoingTitleGuid: string) =>
  apiClient.get<ApiResponse<OhioOutgoingTitleDto>>(`/api/ohio-outgoing-titles/${encodeURIComponent(ohioOutgoingTitleGuid)}`).then(response => response.data)

export const createOhioOutgoingTitleGroup = (values: OhioOutgoingTitleDto) =>
  apiClient.post<ApiResponse<OhioOutgoingTitleDto>>(`/api/ohio-outgoing-titles`, values).then(response => response.data)

export const updateOhioOutgoingTitleGroup = (values: OhioOutgoingTitleDto) =>
  apiClient.put<ApiResponse<OhioOutgoingTitleDto>>(`/api/ohio-outgoing-titles`, values).then(response => response.data)

export const deleteOhioOutgoingTitleGroup = (ohioOutgoingTitleGuid: string) =>
  apiClient.delete<ApiResponse<void>>(`/api/ohio-outgoing-titles/${encodeURIComponent(ohioOutgoingTitleGuid)}`).then(response => response.data)

export const getOhioOutgoingTitleGroupVehicles = (ohioOutgoingTitleGuid: string, parameters: OhioOutgoingTitlesParameters) =>
  apiClient
    .get<ApiResponse<OhioOutgoingTitleDto[]>>(`/api/ohio-outgoing-titles/${encodeURIComponent(ohioOutgoingTitleGuid)}/vehicles` + URIQuery({ ...parameters }))
    .then(response => response.data)

export const addVehiclesToOhioOutgoingTitleGroup = (ohioOutgoingTitleGuid: string, values: OhioOutgoingTitleDto[]) =>
  apiClient
    .post<ApiResponse<OhioOutgoingTitleDto>>(`/api/ohio-outgoing-titles/${encodeURIComponent(ohioOutgoingTitleGuid)}/vehicles`, values)
    .then(response => response.data)

export const removeVehiclesFromOhioOutgoingTitleGroup = (ohioOutgoingTitleGuid: string, values: OhioOutgoingTitleDto[]) =>
  apiClient
    .delete<ApiResponse<OhioOutgoingTitleDto>>(`/api/ohio-outgoing-titles/${encodeURIComponent(ohioOutgoingTitleGuid)}/vehicles`, { data: values })
    .then(response => response.data)

export const lockOhioOutgoingTitleGroup = (ohioOutgoingTitleGuid: string) =>
  apiClient
    .put<ApiResponse<OhioOutgoingTitleDto>>(`/api/ohio-outgoing-titles/${encodeURIComponent(ohioOutgoingTitleGuid)}/lock`)
    .then(response => response.data)

export const unlockOhioOutgoingTitleGroup = (ohioOutgoingTitleGuid: string) =>
  apiClient
    .put<ApiResponse<OhioOutgoingTitleDto>>(`/api/ohio-outgoing-titles/${encodeURIComponent(ohioOutgoingTitleGuid)}/unlock`)
    .then(response => response.data)
